/* eslint-disable complexity */
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import type {
  Abschnitt,
  FilterOptions,
} from '@/domain/mitarbeiter/features/rotationsplan/features/shared/types';

function filterByStandorte<T extends { standortId: string }>(
  items: T[],
  standorte: Standort[],
): T[] {
  if (!standorte.length) return items;
  const ids = new Set(standorte.map((s) => s.id));
  return items.filter((item) => ids.has(item.standortId));
}

function filterByBerufe<T extends { beruf: { name: string } }>(
  items: T[],
  berufe: string[],
): T[] {
  if (!berufe.length) return items;
  const names = new Set(berufe);
  return items.filter((item) => names.has(item.beruf.name));
}

function filterByAbschnitte(
  items: Rotationsplan[],
  abschnitte: Abschnitt[],
): Rotationsplan[] {
  if (!abschnitte.length) return items;
  const names = new Set(abschnitte.map((a) => a.name));
  return items.filter((item) => names.has(item.getCurrentLehrjahr()));
}

export function filterRotationsplaene(
  type: keyof FilterOptions,
  filterInput: FilterOptions[keyof FilterOptions],
  otherFilters: FilterOptions,
  rotationsplaene: Rotationsplan[],
): Rotationsplan[] {
  let filtered = [...rotationsplaene];

  if (filterInput.length > 0) {
    switch (type) {
      case 'standorte':
        filtered = filterByStandorte(filtered, filterInput as Standort[]);
        break;
      case 'berufe':
        filtered = filterByBerufe(filtered, filterInput as string[]);
        break;
      case 'abschnitte':
        filtered = filterByAbschnitte(filtered, filterInput as Abschnitt[]);
        break;
    }
  }

  if (type !== 'berufe') {
    filtered = filterByBerufe(filtered, otherFilters.berufe);
  }
  if (type !== 'abschnitte') {
    filtered = filterByAbschnitte(filtered, otherFilters.abschnitte);
  }
  if (type !== 'standorte') {
    filtered = filterByStandorte(filtered, otherFilters.standorte);
  }

  return filtered;
}
